<div class="flex items-center space-x-3">
  <app-logo-icon />
  <span class="text-lg font-bold text-gray-900 dark:text-gray-100">Summerry</span>
</div>
